const PRIORITY_MAIN = {
  label: "Main",
  id: "main",
  index: 0,
};
const PRIORITY_FALLBACK = {
  label: "Fallback",
  id: "fallback",
  index: 1,
};
const PRIORITY_MAP = {
  [PRIORITY_MAIN.id]: PRIORITY_MAIN,
  [PRIORITY_FALLBACK.id]: PRIORITY_FALLBACK,
};

export { PRIORITY_FALLBACK, PRIORITY_MAIN, PRIORITY_MAP };
